import React from 'react';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

function CustomSpeedDial() {
  return (
    <SpeedDial
      ariaLabel="SpeedDial"
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        color: 'black',                         // Icon color
        '& .MuiSpeedDialIcon-icon': {
          color: 'black',                       // Primary icon color
        },
        '& .MuiButtonBase-root': {
          bgcolor: 'rgba(244,205,24,1)',        // Base button color
          '&:hover': {
            bgcolor: 'rgba(244,205,24,0.8)',    // Adjust hover effect
          },
        },
      }}
      icon={<SpeedDialIcon />}
    >
      {/* Email action */}
      <SpeedDialAction
        icon={<EmailIcon />}
        tooltipTitle="Email Us"
        onClick={() => window.location.href = 'mailto:info@firehemp.com?subject=Wholesale%20Inquiry'}
      />
      
      {/* Phone action */}
      <SpeedDialAction
        icon={<PhoneIcon />}
        tooltipTitle="Call Us"
        onClick={() => window.location.href = 'tel:+18662892796'}
      />

    </SpeedDial>
  );
}

export default CustomSpeedDial;
